import gql from "graphql-tag";
import PostFields from "../../fragments/engagement/PostFields";

export default gql`
  query MostRepliedPosts($top: Int) {
    mostRepliedPosts(top: $top) {
      ...PostFields
    }
  }

  ${PostFields}
`;
